import React, { createContext } from 'react'
// import './sandbox.scss'

import { PageHeader } from '@pushly/aqe/lib/components'

function Sandbox() {
    return <PageHeader title="Sandbox" />
}

export default Sandbox
